import { render, staticRenderFns } from "./btn-text-primary2.vue?vue&type=template&id=1662e698&scoped=true"
import script from "./btn-text-primary2.vue?vue&type=script&lang=js"
export * from "./btn-text-primary2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1662e698",
  null
  
)

export default component.exports